import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, mapTo } from 'rxjs/operators';
import { TelephonyCallPayload, TelephonyCallType } from '@crm/shared/persons/types';
import { CrmApiService } from '@shared/core';
import { DEFAULT_REQUEST_PARAMS } from '@shared/core/types';

@Injectable({
  providedIn: 'root',
})
export class TelephonyApiSharedService extends CrmApiService {
  call(phone: string, type: TelephonyCallType, payload: TelephonyCallPayload): Observable<boolean> {
    return this.api
      .post<any>(`${this.baseEndpoint}telephony/call/`, {
        params: { phone, type, payload },
        ...DEFAULT_REQUEST_PARAMS,
      })
      .pipe(
        mapTo(true),
        catchError((error: HttpErrorResponse) => throwError(error.error)),
      );
  }

  hangUp(): Observable<boolean> {
    return this.api
      .post<any>(`${this.baseEndpoint}telephony/call/hang-up/`, {
        ...DEFAULT_REQUEST_PARAMS,
      })
      .pipe(
        mapTo(true),
        catchError((error: HttpErrorResponse) => throwError(error.error)),
      );
  }
}
